document.addEventListener('DOMContentLoaded', function () {
    const selectMinTags = document.querySelectorAll('.custom-filter__select-min');
    const selectMaxTags = document.querySelectorAll('.custom-filter__select-max');

    if(selectMaxTags.length)
    {
        selectMaxTags.forEach((selectMaxTag) => {
            selectMaxTag.addEventListener('change', function() {
                const updatedMaxValue = Number(selectMaxTag.value);
                const updatedMinValue = Number(selectMaxTag.closest('.custom-filter_select-container').querySelector('.custom-filter__select-min').value);
                const realFilterInputTags = selectMaxTag.closest('.filter__content').querySelectorAll('input');

                if(updatedMaxValue)
                {
                    if(updatedMinValue) {
                        var realFilterMinValue = updatedMaxValue >= updatedMinValue ? updatedMinValue : updatedMaxValue;
                        var realFilterMaxValue = updatedMinValue >= updatedMaxValue ? updatedMinValue : updatedMaxValue;

                        checkRealFilterInputTags(realFilterMinValue, realFilterMaxValue, realFilterInputTags);
                    }
                    else
                    {
                        checkRealFilterInputTags(0, updatedMaxValue, realFilterInputTags);
                    }
                }
                else
                {
                    if(updatedMinValue) {
                        checkRealFilterInputTags(updatedMinValue, 0, realFilterInputTags);
                    }
                    else
                    {
                        checkRealFilterInputTags(0, 0, realFilterInputTags);
                    }
                }
            });
        });
    }

    if(selectMinTags.length) {
        selectMinTags.forEach((selectMinTag) => {
            selectMinTag.addEventListener('change', function() {
                const updatedMinValue = Number(selectMinTag.value);
                const updatedMaxValue = Number(selectMinTag.closest('.custom-filter_select-container').querySelector('.custom-filter__select-max').value);
                const realFilterInputTags = selectMinTag.closest('.filter__content').querySelectorAll('input');

                if(updatedMinValue)
                {
                    if(updatedMaxValue)
                    {
                        
                        var realFilterMinValue = updatedMaxValue >= updatedMinValue ? updatedMinValue : updatedMaxValue;
                        var realFilterMaxValue = updatedMinValue >= updatedMaxValue ? updatedMinValue : updatedMaxValue;

                        checkRealFilterInputTags(realFilterMinValue, realFilterMaxValue, realFilterInputTags);
                    }
                    else
                    {
                        checkRealFilterInputTags(updatedMinValue, 0, realFilterInputTags);
                    }
                }
                else
                {
                    if(updatedMaxValue) {
                        checkRealFilterInputTags(0, updatedMaxValue, realFilterInputTags);
                    }
                    else
                    {
                        checkRealFilterInputTags(0, 0, realFilterInputTags);
                    }
                }
            });
        })
    }

    function checkRealFilterInputTags(min, max, realFilterInputTags) {
        var startIndex = min ? min - 1 : 0;
        var endIndex = max ? max : realFilterInputTags.length;
        
        for(var i = 0; i < realFilterInputTags.length; i++) {
            if(min == 0 && max == 0)
            {
                realFilterInputTags[i].checked = false;
            }
            else
            {
                if(i >= startIndex && i < endIndex)
                {
                    realFilterInputTags[i].checked = true;
                }
                else
                {
                    realFilterInputTags[i].checked = false;
                }
            }
        }
    }
});